import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Button, makeStyles, Theme, Typography } from '@material-ui/core';

const useActionButtonStyles = makeStyles<Theme, ActionButtonProps>((theme) => ({
  root: {
    backgroundColor: 'transparent',
    margin: 0,
    padding: 0,
    textTransform: 'none',
    color: ({ type }) => {
      switch (type) {
        case 'warning':
          return theme.palette.warning.main;
        case 'success':
          return theme.palette.success.main;
        default:
          return theme.palette.secondary.main;
      }
    },
  },
}));

type ActionButtonProps = { type?: 'success' | 'warning' | 'secondary' };
export const ActionButton: React.FC<ActionButtonProps> = ({ type, children, ...rest }) => {
  const classes = useActionButtonStyles({ type });

  return (
    <Button variant='text' {...rest} className={classes.root}>
      <Typography variant='body2'>{children}</Typography>
    </Button>
  );
};
